<template>
  <!-- <div class="row justify-content-md-center my-5"> -->
  <div class="inner-wrapper">
    <div class="row">
      <div class="col-12 col-md-6">
        <h4 class="page-title">Sign in</h4>
        <div class="signin-content">
          <!-- <div class="notification is-info">
          <div v-if="alert.message" :class="'alert ${alert.type}'">
            {{ alert.message }}
          </div>
        </div> -->
          <AlertMessages />

          <form @submit.prevent="login">
            <div class="form-group">
              <!-- Changing the type=email causes pop up validation instead of veulidate -->
              <div class="field-wrapper" v-flyout>
                <input
                  type="text"
                  autocomplete="off"
                  class="text-field-3"
                  id="username"
                  v-model="username"
                  :class="{ 'is-invalid': $v.username.$error }"
                />
                <div class="field-placeholder" v-animate>
                  <span class="asterisk">Enter your email</span>
                </div>
              </div>
              <div v-if="$v.username.$error" class="feedback">
                <span v-if="!$v.username.required">This field is required</span>
                <span v-if="!$v.username.email && $v.Email.$dirty">Incorrect email format</span>
              </div>
            </div>
            <div class="form-group">
              <div class="field-wrapper" v-flyout>
                <input
                  type="password"
                  autocomplete="off"
                  class="text-field-3"
                  id="password"
                  v-model="password"
                  ref="password"
                  :class="{ 'is-invalid': $v.password.$error }"
                />
                <i @click.prevent="showPassword"  :class="iconId"></i>
                <div class="field-placeholder" v-animate>
                  <span class="asterisk">Password</span>
                </div>
              </div>
              <div v-if="$v.password.$error" class="feedback">
                <span v-if="!$v.password.required">This field is required</span>
              </div>
            </div>

            <div class="cta-group">
              <button  class="cta-white-133">
                Sign in<span class="angle-right-white"></span>
              </button>
              <!-- <router-link
            class="cta-white-133"
            :to="{ name: 'overview' }"
            @click.native="login()"
          >
            Sign in<font-awesome-icon icon="angle-right" size="lg"
          /></router-link> -->
              <a role="navigation" tabindex="0" class="forgot-link" @click="routeToForgotPassword()" @keydown.enter="routeToForgotPassword()" >
                Forgot password?</a
              >
            </div>
          </form>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="newuser-container">
          <h4>{{ content.NewUserTitle }}</h4>
          <p>
            {{ content.NewUserText }}
          </p>
          <div class="form-row">
            <button class="cta-green-219 d-flex align-items-center justify-content-center" @click="routeToRegister()" @keydown.enter="routeToRegister()">
              {{ content.NewUserCTA }}<span class="angle-right-green"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { required, email } from "vuelidate/lib/validators";
import AlertMessages from "../components/alert-messages";
import { publicRouter } from "../router";

export default {
  name: "Signin",
  components: { AlertMessages },
  data() {
    return {
      username: "",
      password: "",
      //submitted: false,
      message: "",
      showEyeIcon: false
    };
  },
  validations: {
    username: {
      required,
      email
    },
    password: {
      required
    }
  },
  computed: {
    //...mapState("account", ["status"]),
    ...mapGetters("alert", ["hasError"]),
    ...mapState({ account: state => state.account }),
    ...mapState({
      alert: state => state.alert
    }),
    ...mapState("util", ["content"]),
    iconId() { 
    
      return this.showEyeIcon ? "eye-on" : "eye-off";
    }
  },
  async created() {
    await this.getContent();
  },
  methods: {
    ...mapActions("account", ["signin", "signout"]),
    ...mapActions("alert", ["clear"]),
    ...mapActions("util", ["getContent"]),
showPassword(){
  this.showEyeIcon = !this.showEyeIcon;
    if (this.$refs.password.type == "password") {
        this.$refs.password.type = "text";
      } else {
        this.$refs.password.type="password";
      }
},
    async login() {
      this.clear();
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      await this.signin({ username: this.username, password: this.password });
      if (!this.hasError) {
        if (
          window.location.href ==
          window.location.origin + "/sports-safeguarding-tools/#/"
        ) {
          // for when umbraco redirects not-logged in user to login page but the URL stays as /sports-safeguarding-tools/#/
          window.location.reload();
        } else {
          window.location.href =
            window.location.origin + "/sports-safeguarding-tools/#/";
        }
      }
    },
    routeToForgotPassword() {
      publicRouter.push({ name: "password-reset", query: { id: "1" } });
    },
    routeToRegister(){
       publicRouter.push({ name: "register"});
    }
  }
};
</script>

<style lang="scss"></style>
